import { Liable, Remedy } from '../../../../settlement'
import { DisputeCreateResolution } from './requests.types'
import { AutoDisputeSituation, DisputeType } from './response.types'

export const DISPUTES_URL = '/matching/disputes'

export const DISPUTE_API = '/api/internal/dispute'
export const DISPUTE_REASON_LOOKUP_API = '/api/internal/dispute-reason/lookup'

export const PAGE_SIZE = 50

export const DISPUTE_STATUS_LABEL: Record<string, string> = {
  OPEN: 'Открыт',
  RESOLVED_SUCCESS: 'Завершён успешно',
  RESOLVED_REJECT: 'Отказано',
}

export const DISPUTE_TYPE_OPTIONS: { value: DisputeType; label: string }[] = [
  { value: 'DEPOSIT_DISPUTE', label: 'По депозиту' },
  { value: 'PAYOUT_DISPUTE', label: 'По выплате' },
]

export const AUTO_DISPUTE_SITUATION_LABEL: Record<AutoDisputeSituation, string> = {
  FANTIK: 'Фантик',
  PDF_AUTHENTICITY_REJECTED: 'Отказ проверки подлинности',
  CRITICAL_RECEIPT_CHECK: 'Критичная проверка чека',
  RECEIPT_UNREADABLE: 'Чек нечитаем',
  REPEATED_BANK_ERROR: 'Повторная ошибка банка',
  FIRST_LARGE_TRANSFER: 'Первый крупный перевод',
}

export const DISPUTE_STATUS_BADGE: Record<string, string> = {
  OPEN: 'badge-light-warning',
  RESOLVED_SUCCESS: 'badge-light-success',
  RESOLVED_REJECT: 'badge-light-danger',
}

export const DISPUTES_BREADCRUMBS = [
  { title: 'Мэтчинг', path: '/matching' },
  { title: 'Диспуты', path: DISPUTES_URL },
]

export const DISPUTE_CREATE_OUTCOMES: {
  value: DisputeCreateResolution
  label: string
  notice: string
  submit: string
}[] = [
  {
    value: 'NONE',
    label: 'Не завершать',
    notice:
      'Пока диспут открыт, чек по тикету нельзя подтвердить или отклонить. Закрыть диспут — в разделе «Мэтчинг → Диспуты».',
    submit: 'Создать',
  },
  {
    value: 'REJECT',
    label: 'Автоматически отменить',
    notice:
      'Диспут сразу закроется в пользу платформы, как решение «Отказать». Депозит не будет зачислен, и если оплата подтвердится позже, автоматического зачисления не будет. Занятый слот выплаты освободится сразу.',
    submit: 'Создать и отменить',
  },
  {
    value: 'SUCCESS',
    label: 'Автоматически завершить в успех',
    notice:
      'Диспут сразу закроется в пользу клиента, как решение «Завершить успешно». Клиенту будет зачислена введённая сумма.',
    submit: 'Создать и завершить',
  },
]

// Спор о выплате ничего не замораживает и ничего не меняет — исход пишется только на сам диспут.
export const PAYOUT_DISPUTE_CREATE_OUTCOMES: {
  value: DisputeCreateResolution
  label: string
  notice: string
  submit: string
}[] = [
  {
    value: 'NONE',
    label: 'Не завершать',
    notice: 'Диспут останется открытым. Выплата и депозиты-виновники не меняются. Закрыть диспут — в разделе «Мэтчинг → Диспуты».',
    submit: 'Создать',
  },
  {
    value: 'REJECT',
    label: 'Сразу отказать',
    notice: 'Диспут сразу закроется отказом. Выплата и депозиты-виновники не меняются.',
    submit: 'Создать и отказать',
  },
  {
    value: 'SUCCESS',
    label: 'Сразу завершить успешно',
    notice:
      'Диспут сразу закроется успешно: по каждому виновнику проведётся операция по указанным фактам. Проводки до подтверждения видны только в «Завершить успешно» у открытого диспута.',
    submit: 'Создать и завершить',
  },
]

export const LIABLE_OPTIONS: { value: Liable; label: string }[] = [
  { value: 'DEPOSIT_MERCHANT', label: 'Мерчант пополнения' },
  { value: 'PLATFORM', label: 'Платформа' },
]

export const REMEDY_OPTIONS: { value: Remedy; label: string }[] = [
  { value: 'MERCHANT_SETTLES', label: 'Мерчант выплаты разберётся сам' },
  { value: 'RESEND', label: 'Дошлём мы' },
]
